// extracted by mini-css-extract-plugin
module.exports = {"container":"_2zxSYU3k5OaKt8C6_2UKFy","visible":"_2GcxuLwFdjwBzIgs9kJMMl","cancelBtn":"_1Qz1qcVit8zoFafgOe2sb5","icon":"_6Tfr2tzeHzoFOz4PGHFkK","saveBtn":"_3Jee-oOsWKgIN7gsdH4a1O"};